import {ViewStream} from 'spyne';
import BlogLinkTmpl from './templates/blog-links.tmpl.html'
export class UIBlogLinkView extends ViewStream{
  constructor(props = {}) {

      props.id = 'blog-menu';
      props.channels = [["CHANNEL_ROUTE", true]];
      props.template = BlogLinkTmpl;
      super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [
            ["CHANNEL_ROUTE_CHANGE_EVENT", "disposeViewStream"]


        ];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [
            ['a', 'click']
        ];
    }

    onRendered() {

    }

}

